import { ISchemaDefinition } from ".";

export interface IColelctionObject {
    id: string;
    value: string;
    createdAt: number;
}

export const CollectionObjectsSchema: ISchemaDefinition = {
    collectionName: "collectionObjects",
    properties: [
        {
            key: "id",
            primary: true,
        },
        {
            key: "createdAt",
            index: true,
        },
        {
            key: "value",
        },
    ],
};
